<div class="scrollspy-wrapper">
    <div *ngIf="!showParameters" [ngClass]="{'active':activeSection==='parameters-user'}" class="section-link"
        (click)="scrollTo('parameters-user')"><span i18n="parameters-scrollspy|@@user">Utilisateur</span>
    </div>
    <div *ngIf="showParameters || privateCompany" [ngClass]="{'active':activeSection==='parameters-company'}"
        class="section-link" (click)="scrollTo('parameters-company')"><span
            i18n="parameters-scrollspy|@@company">Compagnie</span>
    </div>
    <div [ngClass]="{'active':activeSection==='parameters-accessibility'}" class="section-link"
        (click)="scrollTo('parameters-accessibility')"><span
            i18n="parameters-scrollspy|@@accessibility">Accessibilité</span>
    </div>
    <div [ngClass]="{'active':activeSection==='parameters-reports'}" class="section-link"
        (click)="scrollTo('parameters-reports')">
        <span i18n="parameters-scrollspy|@@report_settings">Gestion des rapports</span>
    </div>
    <div *ngIf="showParameters" [ngClass]="{'active':activeSection==='parameters-options'}" class="section-link"
        (click)="scrollTo('parameters-options')"><span i18n="parameters-scrollspy|@@options_settings">Gestion des
            options</span>
    </div>
    <div [ngClass]="{'active':activeSection==='parameters-style'}" class="section-link"
        (click)="scrollTo('parameters-style')"><span i18n="parameters-scrollspy|@@custom_style">Style
            Personnalisé</span>
    </div>
    <div *ngIf="showParameters" [ngClass]="{'active':activeSection==='parameters-users'}" class="section-link"
        (click)="scrollTo('parameters-users')"><span i18n="parameters-scrollspy|@@users">Utilisateurs</span>
    </div>
    <div *ngIf="showParameters" [ngClass]="{'active':activeSection==='parameters-vehicle'}" class="section-link"
        (click)="scrollTo('parameters-vehicle')"><span i18n="parameters-scrollspy|@@vehicle">Véhicule</span>
    </div>
    <div *ngIf="showParameters" [ngClass]="{'active':activeSection==='parameters-checkList'}" class="section-link"
        (click)="scrollTo('parameters-checkList')"><span i18n="parameters-scrollspy|@@checkList">CheckList</span>
    </div>
    <div *ngIf="showParameters" [ngClass]="{'active':activeSection==='parameters-cost'}" class="section-link"
        (click)="scrollTo('parameters-cost')"><span i18n="parameters-scrollspy|@@cost">Chiffrage</span>
    </div>
    <div *ngIf="showParameters" [ngClass]="{'active':activeSection==='parameters-tires'}" class="section-link"
        (click)="scrollTo('parameters-tires')">
        <span i18n="parameters-scrollspy|@@tires">Pneus</span>
        <span>
            <svg width="14px" height="16px" viewBox="0 0 14 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
                <title>Lock</title>
                <desc>Created with Sketch.</desc>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="UI-Rapport" transform="translate(-511.000000, -2904.000000)" fill-rule="nonzero">
                        <g id="Content" transform="translate(165.000000, 269.000000)">
                            <g id="07" transform="translate(285.000000, 2632.000000)">
                                <g id="Title" transform="translate(1.000000, 0.000000)">
                                    <path
                                        d="M67,3 C64.8,3 63,4.8 63,7 L63,8 L61,8 C60.4,8 60,8.4 60,9 L60,18 C60,18.6 60.4,19 61,19 L73,19 C73.6,19 74,18.6 74,18 L74,9 C74,8.4 73.6,8 73,8 L71,8 L71,7 C71,4.8 69.2,3 67,3 Z M68,14.7 L68,16 L66,16 L66,14.7 C65.4,14.4 65,13.7 65,13 C65,11.9 65.9,11 67,11 C68.1,11 69,11.9 69,13 C69,13.7 68.6,14.4 68,14.7 Z M69,8 L65,8 L65,7 C65,5.9 65.9,5 67,5 C68.1,5 69,5.9 69,7 L69,8 Z"
                                        id="Shape"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </span>
    </div>
    <div [ngClass]="{'active':activeSection==='parameters-notifications'}" class="section-link"
        (click)="scrollTo('parameters-notifications')"><span
            i18n="parameters-scrollspy|@@notifications">Notifications</span>
    </div>
    <div [ngClass]="{'active':activeSection==='parameters-language'}" class="section-link"
        (click)="scrollTo('parameters-language')"><span i18n="parameters-scrollspy|@@language">Langue</span>
    </div>
    <div *ngIf="showParameters" [ngClass]="{'active':activeSection==='parameters-apiwebhook'}" class="section-link"
        (click)="scrollTo('parameters-apiwebhook')"><span i18n="parameters-scrollspy|@@api_key_and_webhook">Clé API &
            Webhook</span>
    </div>
    <div *ngIf="isSuperAdmin" [ngClass]="{'active':activeSection==='parameters-exportkpi'}" class="section-link"
        (click)="scrollTo('parameters-exportkpi')"><span i18n="parameters-scrollspy|@@exportkpi">Export KPI</span>
    </div>
    <div [ngClass]="{'active':activeSection==='parameters-session'}" class="section-link "
        (click)="scrollTo('parameters-session')"><span i18n="parameters-scrollspy|@@session">Session</span>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-scrollspy/parameters-scrollspy.component.html